import { HttpClientProvider as KyHttpClientProvider } from '@toggl/sync/http/provider';
import React, { useMemo } from 'react';
import { httpClient } from '../../utils';

interface HttpClientProviderProps {
  children: React.ReactNode;
}

export function HttpClientProvider({ children }: HttpClientProviderProps) {
  const extendedHttpClient = useMemo(
    () =>
      httpClient.extend({
        hooks: {
          beforeError: [
            (error) => {
              if (!error.response) {
                // network error
              }

              return error;
            },
          ],
          afterResponse: [
            (_request, _options, _response) => {
              // error from response
            },
          ],
        },
      }),
    []
  );

  return (
    <KyHttpClientProvider client={extendedHttpClient}>
      {children}
    </KyHttpClientProvider>
  );
}
